/** Hand a file to the browser's download (a temporary link, released right after). */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // some browsers read the URL after click() returns
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

/**
 * Download what `url` serves as an attachment (a signed document link): a temporary link click, so the page stays
 * where it is and no tab is opened.
 */
export function downloadUrl(url: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.rel = 'noopener';
  a.download = '';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
